module.exports = __webpack_public_path__ + "img/9788986228533.ad4a7f42.jpg";